import React, { useState, useEffect } from "react";
import { Col, Row, Card, Spin } from "antd";
import {
    InfoCircleOutlined,
    ExclamationCircleOutlined,
    CheckCircleOutlined,
    MinusCircleOutlined,
} from "@ant-design/icons";

const PosCollectionTransactionSummary = (props) => {
    const [summaryData, setSummaryData] = useState({
        data: {
            totalAmount: props.data.totalAmount,
            totalCount: props.data.totalCount,
            successAmount: props.data.successAmount,
            successCount: props.data.successCount,
            errorAmount: props.data.errorAmount,
            errorCount: props.data.errorCount,
            cancelAmount: props.data.cancelAmount,
            cancelCount: props.data.cancelCount,
        },
        loading: false,
    });

    useEffect(() => {
        setSummaryData({
            data: {
                totalAmount: props.data.totalAmount,
                totalCount: props.data.totalCount,
                successAmount: props.data.successAmount,
                successCount: props.data.successCount,
                errorAmount: props.data.errorAmount,
                errorCount: props.data.errorCount,
                cancelAmount: props.data.cancelAmount,
                cancelCount: props.data.cancelCount,
            },
            loading: false,
        });
    }, [props]);

    const formatNumber = (number) => {
        number = parseFloat(number);
        let parts = number.toFixed(2).toString().split(".");
        parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ".");
        return parts.join(",");
    };

    return (
        <Row id="summaryArea" style={{ ...props.style }}>
            <Col span={24}>
                <Card
                    hoverable
                    style={{
                        borderRadius: "10px",
                        boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.1)",
                        background: "linear-gradient(to right, #e3f2fd, #ffffff)",
                    }}
                    bodyStyle={{ padding: 0 }}
                >
                    <Row justify="center">
                        <Col xs={24} style={{ textAlign: 'right', color: "#777", paddingTop: 8, paddingRight: 40, marginBottom: -5, fontSize: 12 }}>
                            <p>Varsayılan olarak son 6 ayın verisi raporlanır.</p>
                        </Col>
                        <Col xs={24} md={12} lg={6} style={{ textAlign: "center" }}>
                            <div style={{ display: "flex", justifyContent: "center", alignItems: "center", gap: "15px", color: "#777" }}>
                                <p>
                                    <InfoCircleOutlined
                                        style={{
                                            color: "blue",
                                            fontSize: "150%",
                                            backgroundColor: "#d6ebf9",
                                            borderRadius: "50%",
                                            padding: "8px",
                                            boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)"
                                        }}
                                    />
                                </p>
                                <h4 style={{ fontWeight: "600", color: "#333" }}>Toplam</h4>
                            </div>
                            <hr style={{ width: "60%", margin: "auto",marginBottom:10 }} />
                            <div style={{ display: "flex", justifyContent: "center", alignItems: "center", gap: "15px", color: "#777" }}>
                                <p>Adet: <span style={{ fontWeight: "500" }}>{summaryData.data.totalCount}</span></p>
                                <p>Tutar: <span style={{ fontWeight: "500" }}>{formatNumber(summaryData.data.totalAmount)}</span></p>
                            </div>
                        </Col>

                        <Col xs={24} md={12} lg={6} style={{ textAlign: "center" }}>
                            <div style={{ display: "flex", justifyContent: "center", alignItems: "center", gap: "15px", color: "#777" }}>
                                <p>
                                    <CheckCircleOutlined
                                        style={{
                                            color: "green",
                                            fontSize: "150%",
                                            backgroundColor: "#E8F5E9",
                                            borderRadius: "50%",
                                            padding: "8px",
                                            boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)"
                                        }}
                                    />
                                </p>
                                <h4 style={{ fontWeight: "600", color: "#333" }}>Başarılı</h4>
                            </div>
                            <hr style={{ width: "60%", margin: "auto",marginBottom:10 }} />
                            <div style={{ display: "flex", justifyContent: "center", alignItems: "center", gap: "15px", color: "#777" }}>
                                <p>Adet: <span style={{ fontWeight: "500" }}>{summaryData.data.successCount}</span></p>
                                <p>Tutar: <span style={{ fontWeight: "500" }}> {formatNumber(summaryData.data.successAmount)}</span></p>
                            </div>
                        </Col>

                        <Col xs={24} md={12} lg={6} style={{ textAlign: "center" }}>
                            <div style={{ display: "flex", justifyContent: "center", alignItems: "center", gap: "15px", color: "#777" }}>
                                <p>
                                    <ExclamationCircleOutlined
                                        style={{
                                            color: "red",
                                            fontSize: "150%",
                                            backgroundColor: "#FFEBEE",
                                            borderRadius: "50%",
                                            padding: "8px",
                                            boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)"
                                        }}
                                    />
                                </p>
                                <h4 style={{ fontWeight: "600", color: "#333" }}>Hatalı</h4>
                            </div>
                            <hr style={{ width: "60%", margin: "auto",marginBottom:10 }} />
                            <div style={{ display: "flex", justifyContent: "center", alignItems: "center", gap: "15px", color: "#777" }}>
                                <p>Adet: <span style={{ fontWeight: "500" }}>{summaryData.data.errorCount}</span></p>
                                <p>Tutar: <span style={{ fontWeight: "500" }}>{formatNumber(summaryData.data.errorAmount)}</span></p>
                            </div>
                        </Col>

                        <Col xs={24} md={12} lg={6} style={{ textAlign: "center", marginBottom: 5 }}>
                            <div style={{ display: "flex", justifyContent: "center", alignItems: "center", gap: "15px", color: "#777" }}>
                                <p>
                                    <MinusCircleOutlined
                                        style={{
                                            color: "purple",
                                            fontSize: "150%",
                                            backgroundColor: "#F3E5F5",
                                            borderRadius: "50%",
                                            padding: "8px",
                                            boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)"
                                        }}
                                    />
                                </p>
                                <h4 style={{ fontWeight: "600", color: "#333" }}>İptal</h4>
                            </div>
                            <hr style={{ width: "60%", margin: "auto",marginBottom:10 }} />
                            <div style={{ display: "flex", justifyContent: "center", alignItems: "center", gap: "15px", color: "#777" }}>
                                <p>Adet: <span style={{ fontWeight: "500" }}>{summaryData.data.cancelCount}</span></p>
                                <p>Tutar: <span style={{ fontWeight: "500" }}> {formatNumber(summaryData.data.cancelAmount)}</span></p>
                            </div>
                        </Col>
                    </Row>
                </Card>
            </Col>
        </Row>
    );
};
export default PosCollectionTransactionSummary;
